<template>
  <nav>
    <button class="nav right" @click="next" :class="{disabled: noshow === true}"><i class="fas fa-angle-right"></i></button>
  </nav>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      noshow () {
        return true}
    },
    methods: {
      next() {
        this.$store.commit('scormLMS/locationPlus');
        this.$store.commit('scormLMS/incrementProgress');
      },
      back() {
        this.$store.commit('scormLMS/locationMinus');
      }
    },
    components: {},
    props: ['items']
  }

</script>

<style scoped>
nav {
  position: absolute;
  bottom: 5px;
  right: 10px;
  z-index: 99;
  background-color: red;
}
.nav {
  background: yellow;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 1.7rem;
  margin: 0 2px;
}
.nav.disabled {
  display: none;
  pointer-events: none;
  cursor: default;
}

</style>



// WEBPACK FOOTER //
// Navigation.vue?1ba3723c